import React from 'react';
import cl from './HomeInfo.module.css';
import { NavLink } from 'react-router-dom';
// import sale from "../../../image/tamanna-rumee-hGLc8L-EcCM-unsplash.jpg";
// import team from "../../../image/startup-594090_1280.jpg";

const HomeInfo = (props) => {
  return (
    <section className={cl.about}>
      <NavLink className={cl.link_image} to="/products">
        <p className={cl.big_image}>SALE</p>
        {/* <img
          className={cl.big_image}
          src={sale}
        /> */}
      </NavLink>
      <NavLink className={cl.link_image} to="/about">
        <p className={cl.big_image}>ABOUT US</p>
        {/* <img
          className={cl.big_image}
          src={team}
        /> */}
      </NavLink>
    </section>
  );
};

export default HomeInfo;
